import {DiscoveryAPI, DiscoveryUnit} from '@udemy/discovery-api';
import {
    IncludedTopicsUnit,
    PopularInstructorsUnit,
    PopularTopicsUnit,
    ProfessionalSkillsUnit,
    CourseUnit,
    SingleCourseUnit,
    SkillsHubCourseUnit,
    ValueProps,
} from '@udemy/react-discovery-units';
import {UDData} from '@udemy/ud-data';

export const getDiscoveryUnitComponentAndPropsFallback = (
    unit: Partial<DiscoveryUnit>,
    unitPropsByType: Record<string, Record<string, unknown>> = {},
) => {
    let Component;
    let contextObject = {};
    let componentProps = {};

    switch (unit.type) {
        case 'bestseller':
            if (unit.view_type === 'default') {
                Component = CourseUnit;
                componentProps = unitPropsByType.CourseUnit || {};
            } else if (unit.view_type === 'horizontal_tabbed') {
                Component = SkillsHubCourseUnit;
                componentProps =
                    unitPropsByType.SkillsHubCourseUnit || unitPropsByType.SkillsHubUnit || {};
                if (unitPropsByType.SkillsHubUnit?.showProfessionalSkillsUnit) {
                    Component = ProfessionalSkillsUnit;
                }
            } else {
                Component = CourseUnit;
                componentProps = unitPropsByType.CourseUnit || {};
            }
            break;
        case 'bestseller_labels':
            contextObject = {
                subcontext: 'affinity',
            };
            if (unit.view_type === 'included_topics') {
                Component = IncludedTopicsUnit;
                componentProps = {};
            } else {
                Component = PopularTopicsUnit;
                componentProps = unitPropsByType.PopularTopicsUnit || {};
            }
            break;
        case 'featured_course':
            contextObject = {
                context2: 'featured',
                subcontext: unit.title,
                subcontext2: unit.id,
            };
            Component = SingleCourseUnit;
            componentProps = unitPropsByType.SingleCourseUnit || {};
            break;
        case 'top_instructor':
            componentProps = {
                context2: 'featured',
                subcontext: unit.title,
                subcontext2: unit.id,
            };
            Component = PopularInstructorsUnit;
            componentProps = {
                componentName: 'popular_instructors_unit',
                ...unitPropsByType.PopularInstructorsUnit,
            };
            break;
        case 'top_pick':
            contextObject = {
                context2: 'featured',
                subcontext: unit.title,
                subcontext2: unit.id,
            };
            Component = SingleCourseUnit;
            componentProps = unitPropsByType.SingleCourseUnit || {};
            break;
        // eventually remove this from Discovery Units and let it be just a normal component
        case 'discovery_value_props': // unit processor
            Component = ValueProps;
            componentProps = unitPropsByType.ValueProps || {};
            break;
        default:
            switch (unit.view_type) {
                case 'horizontal_tabbed':
                    Component = SkillsHubCourseUnit;
                    componentProps =
                        unitPropsByType.SkillsHubCourseUnit || unitPropsByType.SkillsHubUnit || {};
                    if (unitPropsByType.SkillsHubUnit?.showProfessionalSkillsUnit) {
                        Component = ProfessionalSkillsUnit;
                    }
                    break;
                case 'popular_topics':
                    contextObject = {
                        subcontext: 'affinity',
                    };
                    Component = PopularTopicsUnit;
                    componentProps = unitPropsByType.PopularTopicsUnit || {};
                    break;
                case 'single_course':
                    Component = SingleCourseUnit;
                    componentProps = unitPropsByType.SingleCourseUnit || {};
                    break;
                default:
                    throw new Error(
                        `Could not handle a discovery unit case for reported unit type: ${unit.type}`,
                    );
            }
    }

    return {component: Component, contextObject, componentProps};
};

/**
 * Fetch discovery units for a given page type and object id
 * @param udData
 * @param pageType
 * @param pageObjectId
 */
export const fetchDiscoveryUnits = async ({
    udData,
    pageType,
    pageObjectId,
}: {
    udData: UDData;
    pageType: string;
    pageObjectId: number;
}) => {
    const categoryDiscoveryAPI = new DiscoveryAPI({}, udData);
    return await categoryDiscoveryAPI.loadUnits(pageType, {
        pageObjectId,
    });
};
